import { useMemo } from "react";
import difference from "lodash/difference";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import { INTERNAL_DATA_LAKE_ID } from "data-lake/preview/storage-types/internal/Constants";
import hasCustomFields from "data-lake/preview/utils/hasCustomFields";
const getText = (actionItem) => `Newly added ${actionItem} will appear in the log viewer with empty values. To populate these values, you need to re-execute the Data Preview query.`;
const useReexecuteNeedWarning = (config, configBeforeEdit, defaultFields) => {
  const { selectedDataLake } = useSelectedDataLake();
  const widgetHasCustomFields = useMemo(
    () => hasCustomFields(config.fields, defaultFields),
    [config.fields, defaultFields]
  );
  return useMemo(() => {
    if (selectedDataLake.id === INTERNAL_DATA_LAKE_ID && widgetHasCustomFields) {
      return getText("custom fields");
    }
    if (selectedDataLake.id !== INTERNAL_DATA_LAKE_ID && difference(config.fields.toArray(), configBeforeEdit.fields.toArray()).length > 0) {
      return getText("fields");
    }
    return null;
  }, [config.fields, configBeforeEdit.fields, selectedDataLake.id, widgetHasCustomFields]);
};
export default useReexecuteNeedWarning;
